'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRuleCreatePage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/access-rules/new/')({
  component: () => <AccessRuleCreatePage paths={IDP_AUTH_POLICY_PATHS} />
});